export default __webpack_public_path__ + "static/media/3-ADMINISTRATOR.806dc826.pdf";